"use strict";
import { Shine } from "ui/src/loading/Shine";
export const Skeleton = Shine;
